<template>
  <svg
    xmlns="http://www.w3.org/2000/svg"
    :width="width"
    :height="height"
    viewBox="0 0 12 12"
  >
    <g fill="none" fill-rule="evenodd">
      <g fill="#FFF">
        <g>
          <g>
            <g>
              <path
                d="M.131.162C.297-.018.566-.05.766.077L.838.13l6 5.5c.192.177.213.465.064.667l-.064.07-6 5.5c-.204.187-.52.173-.707-.03-.165-.181-.173-.451-.03-.64l.061-.067L5.76 6 .162.869C-.018.703-.05.434.077.234L.13.162z"
                transform="translate(-713 -320) translate(350 290) translate(363 30) translate(3)"
              />
            </g>
          </g>
        </g>
      </g>
    </g>
  </svg>
</template>

<script>
import VueTypes from 'vue-types';
export default {
  name: 'ChevronRightIcon',
  props: {
    height: VueTypes.string.def('12'),
    width: VueTypes.string.def('12'),
  },
};
</script>

<style lang="scss"></style>
